import axios from 'axios'
export default class CurrentUser {
    static instance;
    cacheKey = 'currentUser';

    constructor() {
        console.log('init CurrentUser');
    }

    static getInstance() {
        if(!CurrentUser.instance) {
            CurrentUser.instance = new CurrentUser();
        }

        return CurrentUser.instance;
    }

    getToken() {
        return localStorage.getItem(this.cacheKey);
    }

    login(token) {
        localStorage.setItem(this.cacheKey, token);
        this.setAuthHeader();
    }

    setAuthHeader() {
        const token = this.getToken();
        if(token)
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ token;
    }


    logout() {
        localStorage.removeItem(this.cacheKey);
        delete axios.defaults.headers.common['Authorization'];
    }

}